module.exports = __webpack_public_path__ + "static/media/btn1.698d4ebb.svg";